import Vue from 'vue'
import Vuex from 'vuex'

import feathers from '@/feathers/'

import _debounce from 'lodash.debounce'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    feathers,
    services: {
      auth: feathers.service('authentication'),
      users: feathers.service('users'),
      faq: feathers.service('faq'),
      resources: feathers.service('resources'),
      files: feathers.service('files')
    },
    auth: {
      user: null,
      token: null
    },
    users: {
      items: [],
      totalItems: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null,
      selectedUserType: 'toate',
      approved: null
    },
    faq: {
      items: [],
      allItems: [],
      totalItems: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      }
    },
    resources: {
      items: [],
      allItems: [],
      totalItems: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      }
    },
    files: {
      items: [],
      uploadedDocTypes: [],
      totalItems: 0,
      loading: false,
      tab: 1,
      user_id: null,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['document'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      }
    }
  },
  getters: {
    user: state => state.auth.user,
    token: state => state.auth.token,

    faqAllItems: state => state.faq.allItems,
    faqItems: state => state.faq.items,
    faqOptions: state => state.faq.options,
    faqTotal: state => state.faq.totalItems,
    faqLoading: state => state.faq.loading,

    resourcesAllItems: state => state.resources.allItems,
    resourcesItems: state => state.resources.items,
    resourcesOptions: state => state.resources.options,
    resourcesTotal: state => state.resources.totalItems,
    resourcesLoading: state => state.resources.loading,

    filesItems: state => state.files.items,
    filesOptions: state => state.files.options,
    filesTotal: state => state.files.totalItems,
    filesLoading: state => state.files.loading,

    // startSignup: state => state.flags.items.find(flag => flag.type === 'start inscrieri'),
    // endSignup: state => state.flags.items.find(flag => flag.type === 'sfarsit inscrieri'),
    // startDocs: state => state.flags.items.find(flag => flag.type === 'start incarcare documente'),
    // endDocs: state => state.flags.items.find(flag => flag.type === 'sfrasit incarcare documente'),

    usersItems: state => state.users.items,
    selectedUserType: state => state.users.selectedUserType,
    usersLoading: state => state.users.loading,
    usersOptions: state => state.users.options,
    usersTotal: state => state.users.totalItems,
    filesUserId: state => state.files.user_id,

    uploadedDocTypes: state => state.files.uploadedDocTypes
  },
  mutations: {
    setAuth (state, payload) {
      Vue.set(state.auth, 'user', payload.user)
      Vue.set(state.auth, 'token', payload.accessToken)
    },
    setSelectedUserType (state, payload) {
      Vue.set(state.users, 'selectedUserType', payload)
    },
    setUsersOptions (state, payload) {
      Vue.set(state.users, 'options', payload)
    },
    setUsersLoading (state, payload) {
      Vue.set(state.users, 'loading', payload)
    },
    setUsers (state, payload) {
      if (payload.data) {
        Vue.set(state.users, 'items', payload.data)
        Vue.set(state.users, 'totalItems', payload.total)
      } else {
        Vue.set(state.users, 'items', payload)
        Vue.set(state.users, 'totalItems', payload.length)
      }
    },
    setUsersSearch (state, payload) {
      Vue.set(state.users, 'search', payload)
    },
    setUsersApproved (state, payload) {
      Vue.set(state.users, 'approved', payload)
    },

    setFaqLoading (state, payload) {
      Vue.set(state.faq, 'loading', payload)
    },
    setFaqAll (state, payload) {
      Vue.set(state.faq, 'allItems', payload)
    },
    setFaq (state, payload) {
      if (payload.data) {
        Vue.set(state.faq, 'items', payload.data)
        Vue.set(state.faq, 'totalItems', payload.total)
      } else {
        Vue.set(state.faq, 'items', payload)
        Vue.set(state.faq, 'totalItems', payload.length)
      }
    },
    setFaqOptions (state, payload) {
      Vue.set(state.faq, 'options', payload)
    },

    setFilesLoading (state, payload) {
      Vue.set(state.files, 'loading', payload)
    },
    setFiles (state, payload) {
      if (payload.data) {
        Vue.set(state.files, 'items', payload.data)
        Vue.set(state.files, 'totalItems', payload.total)
      } else {
        Vue.set(state.files, 'items', payload)
        Vue.set(state.files, 'totalItems', payload.length)
      }
    },
    setFilesOptions (state, payload) {
      Vue.set(state.files, 'options', payload)
    },
    setFilesTab (state, payload) {
      Vue.set(state.files, 'tab', payload)
    },
    setFilesUserId (state, payload) {
      if (state.files.user_id === payload) {
        Vue.set(state.files, 'user_id', null)
      } else {
        Vue.set(state.files, 'user_id', payload)
      }
    },

    setResourcesLoading (state, payload) {
      Vue.set(state.resources, 'loading', payload)
    },
    setResources (state, payload) {
      if (payload.data) {
        Vue.set(state.resources, 'items', payload.data)
        Vue.set(state.resources, 'totalItems', payload.total)
      } else {
        Vue.set(state.resources, 'items', payload)
        Vue.set(state.resources, 'totalItems', payload.length)
      }
    },
    setResourcesAll (state, payload) {
      Vue.set(state.resources, 'allItems', payload)
    },
    setResourcesOptions (state, payload) {
      Vue.set(state.resources, 'options', payload)
    },

    setDocumentTypes (state, payload) {
      Vue.set(state.files, 'uploadedDocTypes', payload)
    },

    setSubmitted (state, payload) {
      Vue.set(state.auth.user, 'submitted', payload)
    }
  },
  actions: {
    async login ({ state, commit, dispatch }, payload) {
      if (!payload) {
        return state.feathers.reAuthenticate()
          .then(response => {
            commit('setAuth', response)
            return {
              type: 'success',
              payload: response
            }
          }).catch(err => {
            console.log('reauth error', err)
            return {
              type: 'error',
              payload: err
            }
          })
      } else {
        return state.feathers.authenticate({
          strategy: 'local',
          ...payload
        }).then(response => {
          commit('setAuth', response)
          return {
            type: 'success',
            payload: response
          }
        }).catch(err => {
          console.log('auth error')
          return {
            type: 'error',
            payload: err
          }
        })
      }
    },
    async signup ({ state, commit }, payload) {
      try {
        payload.role = 'aplicant'
        const result = await state.services.users.create(payload)
        console.log(result)
        return true
      } catch (err) {
        console.log('store error', err)
        return err
      }
    },
    logout ({ state, commit }) {
      commit('setAuth', { user: null, accessToken: null })
      return state.feathers.logout()
    },

    fetchUsers: _debounce(async function ({ state, commit }, payload = null) {
      try {
        commit('setUsersLoading', true)

        const query = {}

        if (state.auth.user && state.users.options.itemsPerPage) {
          if (state.users.selectedUserType !== 'toate') {
            query.role = state.users.selectedUserType
          }

          if (state.users.approved !== null) {
            query.approved = state.users.approved
          }

          if (state.users.search) {
            query.$or = [
              { firstName: { $regex: state.users.search, $options: 'ig' } },
              { lastName: { $regex: state.users.search, $options: 'ig' } },
              { email: { $regex: state.users.search, $options: 'ig' } }
            ]
          }

          if (state.users.options.itemsPerPage !== -1) {
            query.$limit = state.users.options.itemsPerPage
            query.$skip = (state.users.options.page - 1) * state.users.options.itemsPerPage
            query.$sort = state.users.options.sortBy.reduce((acc, field, index) => {
              let fld = field

              if (field.includes('.')) {
                fld = field.substring(0, field.indexOf('.'))
              }

              acc[fld] = state.users.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.users.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.users.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        }

        const result = await state.services.users.find({ query })
        commit('setUsers', result)
        commit('setUsersLoading', false)
      } catch (err) {
        console.log(err)
      }
    }, 500),
    setUsersSearch ({ commit, dispatch }, payload) {
      commit('setUsersSearch', payload)
      dispatch('fetchUsers')
    },
    setUsersOptions ({ commit, dispatch }, payload) {
      commit('setUsersOptions', payload)
      dispatch('fetchUsers')
    },
    setSelectedUserType ({ state, commit }, payload) {
      commit('setSelectedUserType', payload)
      this.dispatch('fetchUsers')
    },
    setUsersApproved ({ state, commit }, payload) {
      commit('setUsersApproved', payload)
      this.dispatch('fetchUsers')
    },
    async saveUser ({ state, commit, dispatch }, payload) {
      if (payload._id) {
        try {
          if (!payload.password) delete payload.password

          await state.services.users.patch(payload._id, payload)
          dispatch('fetchUsers')

          return true
        } catch (err) {
          console.log(err)
          return err
        }
      } else {
        try {
          await state.services.users.create(payload)
          dispatch('fetchUsers')

          return true
        } catch (err) {
          console.log(err)
          return err
        }
      }
    },
    async deleteUser ({ state, commit, dispatch }, payload) {
      try {
        await state.services.users.remove(payload)
      } catch (err) {
        console.log(err)
      }
      dispatch('fetchUsers')
    },

    saveUserDetails ({ state }, payload) {
      return state.services.users.patch(state.auth.user._id, { details: payload })
    },

    // fetchFlags: _debounce(async function ({ state, commit }) {
    //   commit('setFlagsLoading', true)
    //   try {
    //     const result = await state.services.flags.find({})
    //     commit('setFlags', result.data)
    //   } catch (err) {
    //     console.log(err)
    //   } finally {
    //     commit('setFlagsLoading', false)
    //   }
    // }, 500),
    // setFlagsOptions ({ commit, dispatch }, payload) {
    //   commit('setFlagsOptions', payload)
    //   dispatch('fetchFlags')
    // },
    // async saveFlag ({ state, dispatch }, payload) {
    //   if (payload._id) {
    //     try {
    //       await state.services.flags.patch(payload._id, payload)
    //       dispatch('fetchFlags')
    //       return true
    //     } catch (err) {
    //       console.log(err)
    //       return err
    //     }
    //   } else {
    //     try {
    //       await state.services.flags.create(payload)
    //       dispatch('fetchFlags')
    //       return true
    //     } catch (err) {
    //       console.log(err)
    //       return err
    //     }
    //   }
    // },
    // async deleteFlag ({ state, dispatch }, payload) {
    //   try {
    //     await state.services.flags.remove(payload)
    //     dispatch('fetchFlags')
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },

    fetchDocumentTypes: _debounce(async function ({ state, commit }) {
      try {
        const result = await state.services.files.find({ query: { $distinct: true } })
        commit('setDocumentTypes', result)
      } catch (err) {
        console.log(err)
      }
    }, 500),
    fetchFiles: _debounce(async function ({ state, commit }) {
      commit('setFilesLoading', true)
      try {
        const query = {
          $populate: [
            { path: 'user_id', model: 'users' },
            { path: 'forUser', model: 'users' }
          ]
        }

        if (state.auth.user.role === 'aplicant') {
          if (state.files.tab === 1) { // my files
            query.user_id = state.auth.user._id
            query.dataType = 'application'
          } else if (state.files.tab === 2) { // my reviews
            query.dataType = 'review'
            query.forUser = state.auth.user._id
          } else {
            query.dataType = 'appeal'
            query.$or = [
              { user_id: state.auth.user._id },
              { forUser: state.auth.user._id }
            ]
          }
        } else {
          if (state.files.tab === 0) { // selected user files
            query.dataType = 'application'
            if (state.files.user_id) {
              query.user_id = state.files.user_id
            }
          } else if (state.files.tab === 1) { // my reviews
            query.dataType = 'review'
            query.user_id = state.auth.user._id
            if (state.files.user_id) {
              query.forUser = state.files.user_id
            }
          } else { // my appeals
            query.dataType = 'appeal'
            if (state.files.user_id) {
              query.$or = [
                { user_id: state.files.user_id }, // incarcate de user sau
                {
                  $and: [
                    { forUser: state.files.user_id }, // incarcate pt user
                    { user_id: state.auth.user._id } // de mine
                  ]
                }
              ]
            } else {
              query.$or = [
                { user_id: state.auth.user._id }, // incarcate de mine sau
                { forUser: null } // incarcate de un user
              ]
            }
          }
        }

        if (state.auth.user && state.files.options.itemsPerPage) {
          if (state.files.options.itemsPerPage !== -1) {
            query.$limit = state.files.options.itemsPerPage
            query.$skip = (state.files.options.page - 1) * state.files.options.itemsPerPage
            query.$sort = state.files.options.sortBy.reduce((acc, field, index) => {
              let fld = field

              if (field.includes('.')) {
                fld = field.substring(0, field.indexOf('.'))
              }

              acc[fld] = state.files.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.files.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.files.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        }

        const result = await state.services.files.find({ query })
        commit('setFiles', result)
      } catch (err) {
        console.log(err)
      } finally {
        commit('setFilesLoading', false)
      }
    }, 500),
    setFilesOptions ({ commit, dispatch }, payload) {
      commit('setFilesOptions', payload)
      dispatch('fetchFiles')
    },
    setFilesTab ({ commit, dispatch }, payload) {
      commit('setFilesTab', payload)
      dispatch('fetchFiles')
      dispatch('fetchDocumentTypes')
    },
    setFilesUserId ({ commit, dispatch }, payload) {
      commit('setFilesUserId', payload)
      dispatch('fetchFiles')
    },
    async saveFile ({ state, dispatch }, payload) {
      let file = null

      payload.user_id = state.auth.user._id
      if (state.auth.user.role === 'evaluator') {
        payload.forUser = state.files.user_id
      }

      if (payload.buffer) {
        try {
          file = await readFile(payload.buffer)
          payload.fileType = payload.buffer.type
          payload.fileExt = payload.buffer.name.split('.').pop()
          payload.buffer = file
        } catch (err) {
          console.log(err)
          return err
        }
      }

      if (payload._id) { // edit file
        try {
          await state.services.files.patch(payload._id, payload)
          await dispatch('fetchFiles')
          await dispatch('fetchDocumentTypes')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      } else { // create file
        try {
          await state.services.files.create(payload)
          await dispatch('fetchFiles')
          await dispatch('fetchDocumentTypes')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      }
    },
    async deleteFile ({ state, dispatch }, payload) {
      try {
        await state.services.files.remove(payload)
        dispatch('fetchFiles')
        dispatch('fetchDocumentTypes')
      } catch (err) {
        console.log(err)
      }
    },

    fetchAllFaq: _debounce(async function ({ state, commit }) {
      commit('setFaqLoading', true)
      try {
        const result = await state.services.faq.find({ query: { $paginate: false, $sort: { index: 1 } } })
        commit('setFaqAll', result)
      } catch (err) {
        console.log(err)
      } finally {
        commit('setFaqLoading', false)
      }
    }, 500),
    fetchFaq: _debounce(async function ({ state, commit }) {
      commit('setFaqLoading', true)
      try {
        const query = {}

        if (state.auth.user && state.faq.options.itemsPerPage) {
          if (state.faq.search) {
            query.$or = [
              { title: { $regex: state.faq.search, $options: 'ig' } },
              { content: { $regex: state.faq.search, $options: 'ig' } }
            ]
          }

          if (state.faq.options.itemsPerPage !== -1) {
            query.$limit = state.faq.options.itemsPerPage
            query.$skip = (state.faq.options.page - 1) * state.faq.options.itemsPerPage
            query.$sort = state.faq.options.sortBy.reduce((acc, field, index) => {
              let fld = field

              if (field.includes('.')) {
                fld = field.substring(0, field.indexOf('.'))
              }

              acc[fld] = state.faq.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.faq.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.faq.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        }

        const result = await state.services.faq.find({ query })
        commit('setFaq', result)
      } catch (err) {
        console.log(err)
      } finally {
        commit('setFaqLoading', false)
      }
    }, 500),
    setFaqOptions ({ commit, dispatch }, payload) {
      commit('setFaqOptions', payload)
      dispatch('fetchFaq')
    },
    async saveFaq ({ state, dispatch }, payload) {
      if (payload._id) {
        try {
          await state.services.faq.patch(payload._id, payload)
          dispatch('fetchFaq')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      } else {
        try {
          await state.services.faq.create(payload)
          dispatch('fetchFaq')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      }
    },
    async deleteFaq ({ state, dispatch }, payload) {
      try {
        await state.services.faq.remove(payload)
        dispatch('fetchFaq')
      } catch (err) {
        console.log(err)
      }
    },

    fetchAllResources: _debounce(async function ({ state, commit }) {
      commit('setResourcesLoading', true)
      try {
        const result = await state.services.resources.find({ query: { $paginate: false, $sort: { index: 1 } } })
        commit('setResourcesAll', result)
      } catch (err) {
        console.log(err)
      } finally {
        commit('setResourcesLoading', false)
      }
    }, 500),
    fetchResources: _debounce(async function ({ state, commit }) {
      commit('setResourcesLoading', true)
      try {
        const query = {}

        if (state.auth.user && state.resources.options.itemsPerPage) {
          if (state.resources.search) {
            query.$or = [
              { title: { $regex: state.resources.search, $options: 'ig' } },
              { content: { $regex: state.resources.search, $options: 'ig' } }
            ]
          }

          if (state.resources.options.itemsPerPage !== -1) {
            query.$limit = state.resources.options.itemsPerPage
            query.$skip = (state.resources.options.page - 1) * state.resources.options.itemsPerPage
            query.$sort = state.resources.options.sortBy.reduce((acc, field, index) => {
              let fld = field

              if (field.includes('.')) {
                fld = field.substring(0, field.indexOf('.'))
              }

              acc[fld] = state.resources.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.resources.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.resources.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        }

        const result = await state.services.resources.find({ query })
        commit('setResources', result)
      } catch (err) {
        console.log(err)
      } finally {
        commit('setResourcesLoading', false)
      }
    }, 500),
    setResourcesOptions ({ commit, dispatch }, payload) {
      commit('setResourcesOptions', payload)
      dispatch('fetchResources')
    },
    async saveResource ({ state, dispatch }, payload) {
      let file = null

      if (payload.thumbBuffer) {
        try {
          file = await readFile(payload.thumbBuffer)
          payload.thumbBuffer = file
        } catch (err) {
          console.log(err)
          return err
        }
      }

      if (payload.fileBuffer) {
        try {
          file = await readFile(payload.fileBuffer)
          payload.fileBuffer = file
        } catch (err) {
          console.log(err)
          return err
        }
      }

      if (payload._id) {
        try {
          await state.services.resources.patch(payload._id, payload)
          dispatch('fetchResources')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      } else {
        try {
          await state.services.resources.create(payload)
          dispatch('fetchResources')
          return true
        } catch (err) {
          console.log(err)
          return err
        }
      }
    },
    async deleteResource ({ state, dispatch }, payload) {
      try {
        await state.services.resources.remove(payload)
        dispatch('fetchResources')
      } catch (err) {
        console.log(err)
      }
    },

    async depunere ({ state, commit }) {
      await state.services.users.patch(state.auth.user._id, { submitted: true })
      commit('setSubmitted', true)
    },

    async undoDepunere ({ state, dispatch }, payload) {
      await state.services.users.patch(payload, { submitted: false })
      dispatch('fetchUsers')
    }
  },
  modules: {
  }
})

function readFile (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = e => {
      var base64 = e.target.result.split('base64,')[1]
      resolve(base64)
    }

    reader.onerror = event => {
      reader.abort()
      reject(new Error('file reader error'))
    }
  })
}
